// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__f5JGd","imageUploader":"EGiftCard_imageUploader__2SUBV"};